import {
  RegisteredBlockWithName,
  UnknownProps,
} from '@tribeplatform/react-slate-kit/types'
import { Icon, SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { DeprecatedBlockBadge } from './Components/DeprecatedBlockBadge.js'
import { NewBlockBadge } from './Components/NewBlockBadge.js'
import { isNewBlock } from './utils.js'

export const AddBlocksSidebarItem = ({
  block,
  onClick,
}: {
  block: RegisteredBlockWithName<UnknownProps>
  onClick: () => void
}) => {
  const isDeprecated = block.config.deprecated
  const isNew = isNewBlock(block.meta?.releaseDate)
  const deprecationMessage = block.meta?.deprecationMessage ?? ''
  const releaseMessage = block.meta?.releaseMessage ?? ''

  return (
    <button
      type="button"
      disabled={isDeprecated}
      onClick={onClick}
      className="w-full py-2 px-5 truncate hover:bg-action-primary hover:text-content-on-primary disabled:bg-surface-disabled disabled:text-content-disabled"
    >
      <div className="flex flex-grow items-center gap-1">
        <Icon size="lg">{block.config.Icon ?? <SvgIcon name="block" />}</Icon>
        <div className="text-start truncate">
          {block.config.displayName ?? block.name}
        </div>
        {isNew && <NewBlockBadge releaseMessage={releaseMessage} />}
        {isDeprecated && !isNew && (
          <DeprecatedBlockBadge deprecationMessage={deprecationMessage} />
        )}
      </div>
    </button>
  )
}
